import React, { createContext, useState, useEffect, useCallback, useRef } from "react";
import { ingestionQueues } from "./service";
import { isUserLoggedIn, showJobQueueNotificationIcon } from "../../../shared/services/shared";

export const JobQueueContext = createContext();
const POLL_INTERVAL = 30000;

export const JobQueueProvider = ({ children }) => {
  const [runningJobCount, setRunningJobCount] = useState(0);
  const [jobQueueModalOpen, setJobQueueModalOpen] = useState(false);
  const isLoggedIn = isUserLoggedIn();
  const showNotificationIcon = showJobQueueNotificationIcon();
  const pollTimerRef = useRef(null); // Persistent ref

  const fetchAndSetRunningJobs = useCallback(async () => {
    try {
      // Only ask the server for the count of not-completed (running) jobs.
      // No documents are fetched — this avoids loading the entire collection
      // on every poll just to show the notification badge.
      const resp = await ingestionQueues({ view: "running", countOnly: true });
      const total = resp?.data?.pagination?.total ?? 0;
      setRunningJobCount(total);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to fetch job queue:", error);
      setRunningJobCount(0);
    }
  }, []);

  useEffect(() => {
    //Set interval only if logged in and flag is enabled
    if (isLoggedIn && showNotificationIcon) {
      fetchAndSetRunningJobs(); // Initial call

      pollTimerRef.current = setInterval(fetchAndSetRunningJobs, POLL_INTERVAL);
    }

    //Cleanup on unmount or login state change
    return () => {
      if (pollTimerRef.current) {
        clearInterval(pollTimerRef.current);
        pollTimerRef.current = null;
      }
    };
  }, [fetchAndSetRunningJobs, isLoggedIn, showNotificationIcon]);

  return (
    <JobQueueContext.Provider
      value={{
        runningJobCount,
        setRunningJobCount,
        refreshRunningJobs: fetchAndSetRunningJobs,
        jobQueueModalOpen,
        setJobQueueModalOpen,
      }}
    >
      {children}
    </JobQueueContext.Provider>
  );
};
